import React from 'react'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI.js'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI.js'
import { Link } from 'react-router-dom'

const ReceivableFinancingPage2UI = ({ context, errorList, loanList, onRefreshClick, openOrClosed, pageTitle }) =>
  <SuperUserHomePageUI context={context} className='pg_su_loan_a_lst' topnav='loans'
    headerText='Loans' centered={!loanList && !errorList} page='rfLoans'
  >
    {/* {
      !loanList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    } */}
    <div className='g_m_left_100 g_large g_m_bottom_100'><b>Receivable Financing Loans</b></div>

    {
      // loanList &&
      <div>
        <LRTableBodyUI>
          <LRTableRowUI
            left={<Link to='/su/accounts/a118da94-7f4e-4da4-ad1e-cf5c6999d450/loans'>Agrosperity Tech</Link>}
          />
          <LRTableRowUI
            left={<Link to='/su/accounts/ece5af6e-a135-463d-9244-d5f4e9e06d9f/loans'>Aksum Trademart</Link>}
          />
          <LRTableRowUI
            left={<Link to='/su/accounts/8ab87fa9-7f47-4f2e-b820-6380c898d204/loans'>Algo Infratech</Link>}
          />
          <LRTableRowUI
            left={<Link to='/su/accounts/afd69053-0bb4-489b-8478-ba08bc58f212/loans'>Brandstore</Link>}
          />
          <LRTableRowUI
            left={<Link to='/su/accounts/df55a6a5-416e-44cd-8719-a88cd6ed2b79/loans'>Drive Unlimited</Link>}
          />
        </LRTableBodyUI>
      </div>
    }
    {
      // loanList && loanList.length !== 0 &&
      // <div className='g_m_top_50'>
      //   <LoanListSF context={context} loanList={loanList} pageTitle={pageTitle}
      //     onRefreshClick={onRefreshClick}
      //   />
      // </div>
    }
    {/* {
      loanList && loanList.length === 0 &&
      <div className='g_m_top_50'>
        <span className='g_flex_h g_flex_left'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>{pageTitle}</b></span>
        </span>
        <EmptyListUI className='g_m_top_200'
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No loans yet'
        />
      </div>
    } */}
  </SuperUserHomePageUI>

export default ReceivableFinancingPage2UI
